/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoicesList_statusTypes$ref: FragmentReference;
declare export opaque type InvoicesList_statusTypes$fragmentType: InvoicesList_statusTypes$ref;
export type InvoicesList_statusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: InvoicesList_statusTypes$ref,
|};
export type InvoicesList_statusTypes$data = InvoicesList_statusTypes;
export type InvoicesList_statusTypes$key = {
  +$data?: InvoicesList_statusTypes$data,
  +$fragmentRefs: InvoicesList_statusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "InvoicesList_statusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1148e3588887f3d3d592b14261a810b2';
module.exports = node;
